const images = require.context("@/assets/images", true, /\.(png|jpe?g|svg)$/);

const ImagePlugin = {
  install(app) {
    app.config.globalProperties.$img = {
      get: (path) => images(`./${path}`),
    };
  },
  get: (path) => images(`./${path}`),
};

export default ImagePlugin;
